import { Query } from '../../../../../hooks/queries'
import { useContrastQuery } from '../../../../../hooks/use-contrast-query'
import { ThisConnector } from '../../../../../api/connector'

interface RbacGroupsArgs {
  organizationUuid: string
}

interface RbacGroupsResponse {
  accessList: any[]
}

export async function getRbacGroups(
  this: ThisConnector,
  { organizationUuid }: RbacGroupsArgs
) {
  return this.connector.get(
    `/api/ui/organizations/${organizationUuid}/access-control-query/action/APPLICATION_VIEW/resource-groups`
  )
}

export const useRbacGroups = ({ organizationUuid }) => {
  const { isLoading, error, data } = useContrastQuery<
    RbacGroupsArgs,
    RbacGroupsResponse
  >([Query.RBAC_RESOURCE_GROUPS, organizationUuid], getRbacGroups, {
    organizationUuid
  })

  return {
    isLoading,
    error,
    data
  }
}
